var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppBar'),_c('Navigation'),_c('v-main',[_c('v-overlay',{attrs:{"value":!_vm.showCharacterGenerator}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),(_vm.showCharacterGenerator)?_c('Content'):_vm._e()],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }